module.exports = __webpack_public_path__ + "img/c1f38cba2298161c05aa2b56c165f60f.gif";